export const PRODUCTION_MODE = '__production_mode__';
export const DEFAULT_AMOUNT_TO_ENABLE_UPI = 500;
export const DEFAULT_AMOUNT_TO_ENABLE_PAYTM = 1000;
export const PACKAGE = 'com.chillar.earncoins.moneymaker';
export const BRAND_NAME = 'Chillar Pro';
export const BRAND_CURRENCY = 'Chillars';
